import { render, staticRenderFns } from "./FCategoriesCom.vue?vue&type=template&id=dd0c2c7c"
import script from "./FCategoriesCom.vue?vue&type=script&lang=js"
export * from "./FCategoriesCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports